export const LOADING = 'myBoards.LOADING';
export const LOADED = 'myBoards.LOADED';